import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'convertFrom24To12Format' })
export class TimeFormatPipe implements PipeTransform {
  transform(time: any): any {
    let { hour, min } = getHourAndMin(time);
    const part = hour >= 12 ? 'pm' : 'am';
    if (hour == 0) {
      hour = 12;
    }

    const minDisplay = (min + '').length == 1 ? `0${min}` : min;
    const formattedHour = hour > 12 ? hour - 12 : hour;
    const hourDisplay = (formattedHour + '').length == 1 ? `0${formattedHour}` : formattedHour;
    return `${hourDisplay}:${minDisplay} ${part}`;
  }
}

function getHourAndMin(time: any) {
  if (time instanceof Date) {
    return {
      hour: time.getHours(),
      min: time.getMinutes(),
    };
  }

  if (typeof time === 'string') {
    const splitForTime = time.includes('T') ? (time.split('T')?.[1] ?? '') : time;
    const split = splitForTime.split(':');
    return {
      hour: parseInt(split[0] ?? 0),
      min: parseInt(split[1] ?? 0),
    };
  }

  return {
    hour: 0,
    min: 0,
  };
}
